/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEventStatus } from './en-event-status';
import { EnExerciseType } from './en-exercise-type';
import { ExerciseDto } from './exercise-dto';
 /**
 *
 *
 * @export
 * @interface EventExerciseDto
 */
export interface EventExerciseDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof EventExerciseDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof EventExerciseDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof EventExerciseDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof EventExerciseDto
     */
    deleted: string | null;

    /**
     * @type {number}
     * @memberof EventExerciseDto
     */
    reps: number;

    /**
     * @type {number}
     * @memberof EventExerciseDto
     */
    sets: number;

    /**
     * @type {number}
     * @memberof EventExerciseDto
     */
    rest: number;

    /**
     * @type {number}
     * @memberof EventExerciseDto
     */
    sequence: number;

    /**
     * @type {number}
     * @memberof EventExerciseDto
     */
    speed: number;

    /**
     * @type {EnExerciseType}
     * @memberof EventExerciseDto
     */
    type: EnExerciseType;

    /**
     * @type {number}
     * @memberof EventExerciseDto
     */
    duration: number;

    /**
     * @type {ExerciseDto}
     * @memberof EventExerciseDto
     */
    exercise: ExerciseDto;

    /**
     * @type {string}
     * @memberof EventExerciseDto
     */
    note?: string;

    /**
     * @type {EnEventStatus}
     * @memberof EventExerciseDto
     */
    status?: EnEventStatus | null;
}
